define("SuiteDB.SDBQuoteImprovements.PlaceOrderButton.View", [
  "suitedb_sdbquoteimprovements_placeorderbutton.tpl",
  "SuiteDB.SDBQuoteImprovements.Modal.View",
  "SDB.SDBLocations.Model",
  "CCAW.OrderTerms.Consent.View",
], function (
  suitedb_sdbquoteimprovements_placeorderbutton_tpl,
  SDBModalContentView,
  SDBLocationsModel,
  ConsentView
) {
  "use strict";

  return Backbone.View.extend({
    template: suitedb_sdbquoteimprovements_placeorderbutton_tpl,
    events: {
      'click [data-action="review-quote-and-order"]': "locationValidation",
    },

    initialize: function initialize(options) {
      this.container = options.container;
      this.locations = SDBLocationsModel.getInstance();
      this.quote = options.quoteInfo;
    },
    locationValidation: function locationValidation(e) {
      try {
        e.preventDefault();
        var selectedLocation = this.locations.getSelectedLocation();
        var locationId =
          (selectedLocation && selectedLocation.internalid) || "6";
        var quoteLocation = this.getQuoteLocation();
        if (quoteLocation != locationId) {
          var layout = this.options.container.getComponent("Layout");
          var modalView = new SDBModalContentView({
            container: this.container,
            reviewQuoteURL: this.quote.reviewQuoteURL,
            model: this.locations,
            nextLocation: _.findWhere(this.locations.getLocations(), {
              internalid: quoteLocation,
            }),
          });
          layout.showContent(modalView, { showInModal: true });
        } else {
          Backbone.history.navigate(this.quote.reviewQuoteURL, {
            trigger: true,
          });
          var container = this.container;
          var layout = container.getComponent("Layout");
          layout.registerView("CCAW.OrderTerms.Consent.View", function () {
            return new ConsentView({
              container: container,
              showOrderTerms: true,
            });
          });
        }
      } catch (error) {
        console.error("error in locationValidation", error);
      }
    },
    getQuoteLocation: function getQuoteLocation() {
      try {
        var location;
        var quote = this.quote;
        if (quote) {
          location = quote.model.get("subsidiary");
        }
        return location;
      } catch (error) {
        console.error("error in getQuoteLocation", error);
      }
    },
    getContext: function getContext() {
      return {
        model: this.quote.model,
      };
    },
  });
});
